export enum NotificationTypes {
    Error,
    Success,
    Warning,
    Info,
}
